import { render, staticRenderFns } from "./DiscussionCommentDelete.vue?vue&type=template&id=60b4cbcc&"
import script from "./DiscussionCommentDelete.vue?vue&type=script&lang=js&"
export * from "./DiscussionCommentDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports